export default __webpack_public_path__ + "static/media/cowboy.492f143e.png";